import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CheckoutService} from '../../shared/services/checkout.service';
import {CheckoutSuccessData} from '../../shared/model/checkout-success-data';
import {Dtm, getDtm, Mapping} from '../../shared/enum/dtm';
import {DtmService} from '../../services/dtm.service';
import {SYDLEClientID} from '../../shared/constants/one-constants';
import {ActivatedRoute} from "@angular/router";
import {SessionStorageService} from "../../shared/services/session-storage.service";

@Component({
    selector: "pme-self-attendance-processing",
    templateUrl: "./processing.component.html",
    styleUrls: ["./processing.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendanceProcessingComponent implements OnInit, OnDestroy{

  checkoutSuccessData: CheckoutSuccessData;

  // HTML Info
  paymentMethod: string;
  totalValue: number;
  code: string;
  brand: string;
  redirectUrl = 'https://empresas.serasaexperian.com.br/';

  buttonName = 'Ok entendi';

  // Provisioning Parameters variables
  userId: string;
  businessId: string;
  couponAmount: number;
  showHero: boolean;
  classificationIdentifier: string;
  automaticRecharge: string;

  constructor(
    private checkoutService: CheckoutService,
    public dtmService: DtmService,
    private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService
  ) {
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);

    // Adobe Analytics
    this.dtmService.pageLoaded(Dtm.Processando, true, getDtm(Dtm.Processando, this.classificationIdentifier));
    this.dtmService.customLoaded(["Checkout"], 'Sydle-processando-pedido');

    if (!this.checkoutService.getCheckoutSuccessData()) {
      this.checkoutService.getSessionCheckoutSuccessData();
    }

    this.checkoutSuccessData = this.checkoutService.getCheckoutSuccessData();
    if (this.checkoutSuccessData.contract.product.classificationIdentifier === "consulta-e-recuperacao-de-dividas") {
      let automaticRechargeValue = this.checkoutSuccessData.contract.product.automaticRecharge;
      this.automaticRecharge = Number.isInteger(automaticRechargeValue) ? automaticRechargeValue.toString() : automaticRechargeValue.toFixed(2).replace('.',',').toString();
    }
  }


  ngOnInit(): void {
    if (!this.checkoutService.getCheckoutSuccessData()) {
      this.ngOnDestroy();
    } else {

      if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'BANK_BILLET') {
        this.totalValue = this.checkoutSuccessData.bankBilletData.totalValue;
        this.couponAmount = this.checkoutSuccessData.bankBilletData.discountedValue;
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'PIX') {
        this.totalValue = this.checkoutSuccessData.pixData.totalValue;
        this.couponAmount = this.checkoutSuccessData.pixData.discountedValue;
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD') {
        this.totalValue = this.checkoutSuccessData.creditCardData.totalValue;
        this.couponAmount = this.checkoutSuccessData.creditCardData.discountedValue;
      }

      this.redirectUrl = this.checkoutSuccessData.redirectUrl || this.redirectUrl;
      this.buttonName = this.checkoutSuccessData.buttonCTA || this.buttonName;


      this.dtmService.productsLoaded([{
        identifier: this.checkoutSuccessData.contract.product.identifier,
        classificationName: this.checkoutSuccessData.contract.product.classificationName ? Mapping[this.checkoutSuccessData.contract.product.classificationName]?Mapping[this.checkoutSuccessData.contract.product.classificationName] : this.checkoutSuccessData.contract.product.classificationName : null,
        quantity: 1,
        totalValue: this.totalValue
      }]);

      this.dtmService.userLoaded({
        userId: this.checkoutSuccessData.contract.provisioningParameters.userId,
        businessId: this.checkoutSuccessData.contract.provisioningParameters.businessId,
        clientId: SYDLEClientID,
      });

      this.dtmService.checkoutSuccess({
        orderId: this.checkoutSuccessData.contract.code, // OrderID OTC
        orderEventId: this.checkoutSuccessData.creditCardData ? this.checkoutSuccessData.creditCardData.invoiceId : this.checkoutSuccessData.bankBilletData ? this.checkoutSuccessData.bankBilletData.invoiceId : '',
        totalPrice: this.checkoutSuccessData.bankBilletData
          ? this.checkoutSuccessData.bankBilletData.totalValue
          : this.checkoutSuccessData.creditCardData
            ? this.checkoutSuccessData.creditCardData.totalValue
            : '',
        coupon: null,
        changeType: 'processando-pedido',
      });

      this.dtmService.sendPageLoadEvent();

      this.clearSessionStorage();
    }
  }

  onSuccessClick() {
    this.dtmService.customClickEvent(this.buttonName);
    document.location.href = this.redirectUrl;
  }


  clearSessionStorage() {
    // sessionStorage.clear();
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('paymentMethod');
    sessionStorage.removeItem('businessId');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('currentStep');
    sessionStorage.removeItem('coupon');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
  }

  ngOnDestroy(): void {
    sessionStorage.clear();
    sessionStorage.removeItem('dataLayer');
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('paymentMethod');
    sessionStorage.removeItem('businessId');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('category');
    sessionStorage.removeItem('plan');
    sessionStorage.removeItem('currentStep');
    sessionStorage.removeItem('coupon');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    localStorage.removeItem('checkoutSuccessData');
    sessionStorage.removeItem('identificationCompleted');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    document.location.href = this.redirectUrl;
  }

}
